import { createContext, useContext, ReactNode } from 'react';

interface SignInContextType {
  showErrorBox: boolean;
  setShowErrorBox: (_show: boolean) => void;
  errorMsg: string[];
  setErrorMsg: (_errors: string[]) => void;
  serverErrorMsg: string[];
  setServerErrorMsg: (_errors: string[]) => void;
  isSubmitDisabled: boolean;
  setIsSubmitDisabled: (_disabled: boolean) => void;
  isFromIframe?: boolean;
}

const SignInContext = createContext<SignInContextType | undefined>(undefined);

export const useSignInContext = () => {
  const context = useContext(SignInContext);
  if (!context) {
    throw new Error('useSignInContext must be used within a SignInContextProvider');
  }
  return context;
};

interface SignInContextProviderProps {
  children: ReactNode;
  value: SignInContextType;
}

export const SignInContextProvider = ({ children, value }: SignInContextProviderProps) => (
  <SignInContext.Provider value={value}>{children}</SignInContext.Provider>
);
